export const CLRS = {
  // PRIMARY:"#a43136",
  PRIMARY: "#0858f7",
  WHITE: "#FFFFFF",
  BLACK: "#000000",
  MEAT_BLACK: "#2A2A2A",
  SECONDARY: "#C7C7C7",
  MATTBLACK: "#2F3133",
  RED: "#FB4254",
  GREEN: "#0CC777",
  PRIMARY_BACKGROUND: "#D7EEFF",
  GREENPRIMARY: "#8BB5A2",
  NEWBLUE: "#6161A4",
  NEWYELLOW: "#D8C892",
  LIGHTRED: "#D86565",
  GRAY: "#A1B1AD",
  LIGHTGRAY: "#777",
};
export const ALL_OBJ = { id: "All", name: "ALL", label: "ALL", value: "All" };
export const Toast_Massages = {
  No_net: "You are not connected to the internet",
  wrong: "Something went wrong please try again later",
  trans_error: "Transaction failed, please try again",
};

export const PLANCARDCOLORS = ["#FC471D", "#26DF91", "#FFB72C", "#ED2020"];
